import { Box, Center, Grid, GridItem, HStack, Text } from "@chakra-ui/react";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";
import bgImage from "../img/upcomingTrBG.svg";

import location from "../img/locationVector.svg";
import mail from "../img/mailVector.svg";
import paper from "../img/paperVector.svg";
import phone from "../img/phoneVector.svg";

const TrainingCenters = () => {
  interface ITrainingCenters {
    name: string;
    mail: string;
    phone: string;
    location: string;
    city: string;
  }

  const trainingCenters: ITrainingCenters[] = [
    {
      name: "MAIN CAMPUS",
      mail: "info@naptin.org.ng",
      phone: "07067777559",
      location:
        "Plot 21 Cadastral Zone, Idu Industrial Area, Near Wupa Sewage Plant, Airport Road, Abuja",
      city: "Abuja",
    },
    {
      name: "RTC AFAM",
      mail: "rtcafam@naptin.org.ng",
      phone: "08037731238",
      location:
        "Opposite Phcn Afam Power Station, Oyigbo Lg Hqtrs, Rivers State-Nigeria",
      city: "Rivers",
    },
    {
      name: "RTC AKANGBA",
      mail: "rtcakangba@naptin.org.ng",
      phone: "08023383636",
      location: "No. 73 Adelabu Off Alhaji Masha Bus Stop, Surulere, Lagos",
      city: "Lagos",
    },
    {
      name: "RTC IJORA",
      mail: "rtcijora@naptin.org.ng",
      phone: "08033203442",
      location:
        "Opposite Ijora Olopa, Beside Old Power Station, Lagos State-Nigeria",
      city: "Lagos",
    },
    {
      name: "RTC JOS",
      mail: "rtcjos@naptin.org.ng",
      phone: "08037900809",
      location:
        "Government House Road, Opposite Nta College, Rayfield, Jos. Plateau State, Nigeria",
      city: "Plateau",
    },
    {
      name: "MAIN CAMPUS",
      mail: "rtckaduna@naptin.org.ng",
      phone: "08033202596",
      location: "Kachia/Junction Road, Near Old Power House, Kaduna- Nigeria",
      city: "Kaduna",
    },
  ];

  return (
    <>
      <Header />
      <Box width="100%">
        <Box
          bgImage={bgImage}
          bgRepeat="no-repeat"
          objectFit="cover"
          bgSize="cover"
          pt={["30px", "72px"]}
        >
          <Box pt="80px" px="5%" pb="50px">
            <Text
              fontSize={["40px", "48px"]}
              color="white"
              fontWeight="800"
              textAlign="left"
            >
              Training Centers
            </Text>
            <Text
              mt="25px"
              textAlign="left"
              fontWeight="400"
              color="white"
              fontSize={["16px", "22px"]}
            >
              NAPTIN has different Regional Training Centers (RTC) <br></br>
              located in different States across Nigeria.
            </Text>
            <Text
              mt="25px"
              textAlign="left"
              fontWeight="400"
              color="white"
              fontSize={["16px", "22px"]}
            >
              Training Programs, Workshops, Seminars, Exhibitions <br></br>etc
              are conducted in these Training Centres.
            </Text>
          </Box>
        </Box>
        <Center
          paddingY="4rem"
          bg="#F9F9F9"
          paddingX={["0.5rem", "1rem", "1rem", "1rem"]}
        >
          <Grid
            templateColumns={[
              "repeat(1, 1fr)",
              "repeat(2, 1fr)",
              "repeat(2, 1fr)",
              "repeat(3, 1fr)",
            ]}
            gap={["1.5rem", "1rem", "1.5rem", "1.6rem"]}
            paddingX={["0.5rem", "1rem", "1rem", "1rem"]}
          >
            <GridItem width="320px" height="auto">
              <Center
                bgColor="#7B61FF"
                height="55px"
                borderTopLeftRadius="10px"
                borderTopRightRadius="10px"
              >
                <Text color="#FFFFFF" fontWeight="700" fontSize="16px">
                  MAIN CAMPUS
                </Text>
              </Center>
              <Box
                bgColor="white"
                height="14rem"
                paddingX="2.2rem"
                paddingY="1.2rem"
                fontSize="14px"
                borderBottomLeftRadius="10px"
                borderBottomRightRadius="10px"
              >
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={mail} alt="" />
                  <Text>info@naptin.org.ng</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={phone} alt="" />
                  <Text>07067777559</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={location} alt="" />
                  <Text>
                    Plot 21 Cadastral Zone, Idu <br></br>Industrial Area, Near
                    Wupa <br></br>Sewage Plant, Airport Road, <br></br>Abuja
                  </Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={paper} alt="" />
                  <Text>Abuja</Text>
                </HStack>
              </Box>
            </GridItem>
            <GridItem width="320px" height="auto">
              <Center
                bgColor="#7B61FF"
                height="55px"
                borderTopLeftRadius="10px"
                borderTopRightRadius="10px"
              >
                <Text color="#FFFFFF" fontWeight="700" fontSize="16px">
                  RTC AFAM
                </Text>
              </Center>
              <Box
                bgColor="white"
                height="14rem"
                paddingX="2.2rem"
                paddingY="1.2rem"
                fontSize="14px"
                borderBottomLeftRadius="10px"
                borderBottomRightRadius="10px"
              >
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={mail} alt="" />
                  <Text>rtcafam@naptin.org.ng</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={phone} alt="" />
                  <Text>08037731238</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={location} alt="" />
                  <Text>
                    Opposite Phcn Afam Power Station, <br></br>Oyigbo Lg Hqtrs,
                    Rivers <br></br>State-Nigeria
                  </Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={paper} alt="" />
                  <Text>Rivers</Text>
                </HStack>
              </Box>
            </GridItem>
            <GridItem width="320px" height="auto">
              <Center
                bgColor="#7B61FF"
                height="55px"
                borderTopLeftRadius="10px"
                borderTopRightRadius="10px"
              >
                <Text color="#FFFFFF" fontWeight="700" fontSize="16px">
                  RTC AKANGBA
                </Text>
              </Center>
              <Box
                bgColor="white"
                height="14rem"
                paddingX="2.2rem"
                paddingY="1.2rem"
                fontSize="14px"
                borderBottomLeftRadius="10px"
                borderBottomRightRadius="10px"
              >
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={mail} alt="" />
                  <Text>rtcakangba@naptin.org.ng</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={phone} alt="" />
                  <Text>08023383636</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={location} alt="" />
                  <Text>
                    No. 73 Adelabu Off Alhaji Masha Bus<br></br>
                    Stop, Surulere, Lagos
                  </Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={paper} alt="" />
                  <Text>Lagos</Text>
                </HStack>
              </Box>
            </GridItem>
            <GridItem width="320px" height="auto">
              <Center
                bgColor="#7B61FF"
                height="55px"
                borderTopLeftRadius="10px"
                borderTopRightRadius="10px"
              >
                <Text color="#FFFFFF" fontWeight="700" fontSize="16px">
                  RTC IJORA
                </Text>
              </Center>
              <Box
                bgColor="white"
                height="14rem"
                paddingX="2.2rem"
                paddingY="1.2rem"
                fontSize="14px"
                borderBottomLeftRadius="10px"
                borderBottomRightRadius="10px"
              >
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={mail} alt="" />
                  <Text>rtcijora@naptin.org.ng</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={phone} alt="" />
                  <Text>08033203442</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={location} alt="" />
                  <Text>
                    Opposite Ijora Olopa, Beside Old <br></br> Power Station,
                    Lagos State-<br></br>Nigeria
                  </Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={paper} alt="" />
                  <Text>Lagos</Text>
                </HStack>
              </Box>
            </GridItem>
            <GridItem width="320px" height="auto">
              <Center
                bgColor="#7B61FF"
                height="55px"
                borderTopLeftRadius="10px"
                borderTopRightRadius="10px"
              >
                <Text color="#FFFFFF" fontWeight="700" fontSize="16px">
                  RTC JOS
                </Text>
              </Center>
              <Box
                bgColor="white"
                height="14rem"
                paddingX="2.2rem"
                paddingY="1.2rem"
                fontSize="14px"
                borderBottomLeftRadius="10px"
                borderBottomRightRadius="10px"
              >
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={mail} alt="" />
                  <Text>rtcjos@naptin.org.ng</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={phone} alt="" />
                  <Text>08037900809</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={location} alt="" />
                  <Text>
                    Government House Road, <br></br>
                    Opposite Nta College, Rayfield<br></br>Jos. Plateau State,
                    Nigeria.
                  </Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={paper} alt="" />
                  <Text>Plateau</Text>
                </HStack>
              </Box>
            </GridItem>
            <GridItem width="320px" height="auto">
              <Center
                bgColor="#7B61FF"
                height="55px"
                borderTopLeftRadius="10px"
                borderTopRightRadius="10px"
              >
                <Text color="#FFFFFF" fontWeight="700" fontSize="16px">
                  KADUNA CAMPUS
                </Text>
              </Center>
              <Box
                bgColor="white"
                height="14rem"
                paddingX="2.2rem"
                paddingY="1.2rem"
                fontSize="14px"
                borderBottomLeftRadius="10px"
                borderBottomRightRadius="10px"
              >
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={mail} alt="" />
                  <Text>rtckaduna@naptin.org.ng</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={phone} alt="" />
                  <Text>08033202596</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={location} alt="" />
                  <Text lineHeight="22px">
                    Kachia/Junction Road, Near Old<br></br>Power House, Kaduna-
                    Nigeria
                  </Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={paper} alt="" />
                  <Text>Kaduna</Text>
                </HStack>
              </Box>
            </GridItem>
            <GridItem width="320px" height="auto">
              <Center
                bgColor="#7B61FF"
                height="55px"
                borderTopLeftRadius="10px"
                borderTopRightRadius="10px"
              >
                <Text color="#FFFFFF" fontWeight="700" fontSize="16px">
                  RTC KAINJI
                </Text>
              </Center>
              <Box
                bgColor="white"
                height="14rem"
                paddingX="2.2rem"
                paddingY="1.2rem"
                fontSize="14px"
                borderBottomLeftRadius="10px"
                borderBottomRightRadius="10px"
              >
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={mail} alt="" />
                  <Text>rtckainji@naptin.org.ng</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={phone} alt="" />
                  <Text>08057069983</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={location} alt="" />
                  <Text lineHeight="22px">
                    Opposite Kainji Hydro Station, New Bussa Lg Niger State-
                    Nigeria
                  </Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={paper} alt="" />
                  <Text>Niger</Text>
                </HStack>
              </Box>
            </GridItem>
            <GridItem width="320px" height="auto">
              <Center
                bgColor="#7B61FF"
                height="55px"
                borderTopLeftRadius="10px"
                borderTopRightRadius="10px"
              >
                <Text color="#FFFFFF" fontWeight="700" fontSize="16px">
                  RTC KANO
                </Text>
              </Center>
              <Box
                bgColor="white"
                height="14rem"
                paddingX="2.2rem"
                paddingY="1.2rem"
                fontSize="14px"
                borderBottomLeftRadius="10px"
                borderBottomRightRadius="10px"
              >
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={mail} alt="" />
                  <Text>rtckano@naptin.org.ng</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={phone} alt="" />
                  <Text>08023074609</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={location} alt="" />
                  <Text lineHeight="22px">
                    Challawa Old Power Station House, Panshekara, Kunbotso Lg,
                    Kano State- Nigeria
                  </Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={paper} alt="" />
                  <Text>Kano</Text>
                </HStack>
              </Box>
            </GridItem>
            <GridItem width="320px" height="auto">
              <Center
                bgColor="#7B61FF"
                height="55px"
                borderTopLeftRadius="10px"
                borderTopRightRadius="10px"
              >
                <Text color="#FFFFFF" fontWeight="700" fontSize="16px">
                  RTC OJI
                </Text>
              </Center>
              <Box
                bgColor="white"
                height="14rem"
                paddingX="2.2rem"
                paddingY="1.2rem"
                fontSize="14px"
                borderBottomLeftRadius="10px"
                borderBottomRightRadius="10px"
              >
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={mail} alt="" />
                  <Text>rtcoji@naptin.org.ng</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={phone} alt="" />
                  <Text>08035471347</Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={location} alt="" />
                  <Text lineHeight="22px">
                    Oji River Power Station, Tema Power Station, Enugu State -
                    Nigeria
                  </Text>
                </HStack>
                <HStack spacing="2rem" mt="0.5rem">
                  <img src={paper} alt="" />
                  <Text>Enugu</Text>
                </HStack>
              </Box>
            </GridItem>

            {/* <GridItem width="320px" height="auto">
                        <Center bgColor="#7B61FF" height="55px" borderTopLeftRadius="10px" borderTopRightRadius="10px">
                            <Text color="#FFFFFF" fontWeight="700" fontSize="16px">MAIN CAMPUS</Text>
                        </Center>
                        <Box bgColor="white" paddingX="2.2rem" paddingY="1.2rem" fontSize="14px" borderBottomLeftRadius="10px" borderBottomRightRadius="10px">
                            <HStack spacing="2rem" mt="0.5rem">
                                <img src={mail} alt=""/>
                                <Text>info@naptin.org.ng</Text>
                            </HStack>
                            <HStack spacing="2rem" mt="0.5rem">
                                <img src={phone} alt=""/>
                                <Text>07067777559</Text>
                            </HStack>
                            <HStack spacing="2rem" mt="0.5rem">
                                <img src={location} alt=""/>
                                <Text>
                                    Plot 21 Cadastral Zone,
                                    Idu <br></br>Industrial Area, 
                                    Near Wupa <br></br>Sewage Plant, 
                                    Airport Road, <br></br>Abuja
                                </Text>
                            </HStack>
                            <HStack spacing="2rem" mt="0.5rem">
                                <img src={paper} alt=""/>
                                <Text>Abuja</Text>
                            </HStack>
                        </Box>
                    </GridItem>
                    <GridItem width="320px" height="auto">
                        <Center bgColor="#7B61FF" height="55px" borderTopLeftRadius="10px" borderTopRightRadius="10px">
                            <Text color="#FFFFFF" fontWeight="700" fontSize="16px">MAIN CAMPUS</Text>
                        </Center>
                        <Box bgColor="white" paddingX="2.2rem" paddingY="1.2rem" fontSize="14px" borderBottomLeftRadius="10px" borderBottomRightRadius="10px">
                            <HStack spacing="2rem" mt="0.5rem">
                                <img src={mail} alt=""/>
                                <Text>info@naptin.org.ng</Text>
                            </HStack>
                            <HStack spacing="2rem" mt="0.5rem">
                                <img src={phone} alt=""/>
                                <Text>07067777559</Text>
                            </HStack>
                            <HStack spacing="2rem" mt="0.5rem">
                                <img src={location} alt=""/>
                                <Text>
                                    Plot 21 Cadastral Zone,
                                    Idu <br></br>Industrial Area, 
                                    Near Wupa <br></br>Sewage Plant, 
                                    Airport Road, <br></br>Abuja
                                </Text>
                            </HStack>
                            <HStack spacing="2rem" mt="0.5rem">
                                <img src={paper} alt=""/>
                                <Text>Abuja</Text>
                            </HStack>
                        </Box>
                    </GridItem> */}
          </Grid>
        </Center>

        {/* <SafeSecure /> */}
      </Box>
      <Footer />
    </>
  );
};

export default TrainingCenters;
